import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'devclinic',
});

export const examRoomRouteRef = createSubRouteRef({
  id: 'devclinic:exam-room',
  parent: rootRouteRef,
  path: '/room/:slug',
});
